import React, {
  ReactElement,
  ReactNode,
  createContext,
  useContext,
  useMemo,
  useState
} from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

interface NetworkClientContextModel {
  headers?: Record<string, string>;
}

const defaultContextValue: NetworkClientContextModel = {
  headers: undefined
};

const NetworkClientContext = createContext(defaultContextValue);

export function NetworkClientProvider({
  headers,
  children
}: {
  headers?: Record<string, string>;
  children: ReactNode;
}): ReactElement {
  const [_headers, _setHeaders] = useState<Record<string, string> | undefined>(headers);

  const queryClient = useMemo(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            // Too noisy, can enable for certain queries if we want
            refetchOnWindowFocus: false
          }
        }
      }),
    []
  );

  return (
    <NetworkClientContext.Provider value={{ headers: headers }}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </NetworkClientContext.Provider>
  );
}

export function useNetworkClient() {
  return useContext(NetworkClientContext);
}
